export default __webpack_public_path__ + "static/media/Untitled.9dc0eea8.png";